module.exports = __webpack_public_path__ + "img/facts-capacity.a9a28479.svg";